import state from "@/store/modules/report-products/state";
import actions from "@/store/modules/report-products/actions";
import mutations from "@/store/modules/report-products/mutations";
import getters from "@/store/modules/report-products/getters";

export default {
    state,
    actions,
    mutations,
    getters
}